import { render, staticRenderFns } from "./DeviceRelationAssignList.vue?vue&type=template&id=78799186&"
import script from "./DeviceRelationAssignList.vue?vue&type=script&lang=ts&"
export * from "./DeviceRelationAssignList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports